module.exports = __webpack_public_path__ + "img/icon_popup_close_black.67d67699.png";